import { render, staticRenderFns } from "./TravellerInfo.vue?vue&type=template&id=2589f9dc&scoped=true"
import script from "./TravellerInfo.vue?vue&type=script&lang=js"
export * from "./TravellerInfo.vue?vue&type=script&lang=js"
import style0 from "./TravellerInfo.vue?vue&type=style&index=0&id=2589f9dc&prod&lang=css"
import style1 from "./TravellerInfo.vue?vue&type=style&index=1&id=2589f9dc&prod&scoped=true&lang=scss"
import style2 from "./TravellerInfo.vue?vue&type=style&index=2&id=2589f9dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2589f9dc",
  null
  
)

export default component.exports